export default `
<time datetime="{{raw}}" class="{{class}} time">
  {{formatJsonDate value}}
</time>
`;
